export const CURRENT_SALON_RESET = 'CURRENT_SALON_RESET';
export const UPDATE_SALON_DATA_SUCCESS = 'UPDATE_SALON_DATA_SUCCESS';
export const SALON_DETAILS_SUCCESS = 'SALON_DETAILS_SUCCESS';
export const CLIENT_LIST_SUCCESS = 'CLIENT_LIST_SUCCESS';
export const CLIENT_LIST_REQUEST = 'CLIENT_LIST_REQUEST';
export const CLIENT_LIST_FAILURE = 'CLIENT_LIST_FAILURE';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const REORDER_STYLISTS = 'REORDER_STYLISTS';
export const CLIENT_PUSHER = 'CLIENT_PUSHER';
export const SALON_STRIPE_SETUP = 'SALON_STRIPE_SETUP';
export const SALON_DETAILS_REQUEST = 'SALON_DETAILS_REQUEST';
export const SALON_DETAILS_ERROR = 'SALON_DETAILS_ERROR';
export const DELETE_STYLIST_SUCCESS = 'DELETE_STYLIST_SUCCESS';
export const EDIT_STYLIST_SUCCESS = 'EDIT_STYLIST_SUCCESS';
export const ADD_STYLIST_SUCCESS = 'ADD_STYLIST_SUCCESS';
export const UPDATE_SALON_DATA_REQUEST = 'UPDATE_SALON_DATA_REQUEST';
export const UPDATE_SALON_DATA_FAILURE = ' UPDATE_SALON_DATA_FAILURE';

export const currentSalonInit = () => ({
  lists: {
    clients: null,
    stylists: null,
    services: null,
  },
  id: 0,
  name: '',
  clientList: [],
  stylistList: [],
  services: [],
  isFetchingClientList: false,
  requestedClientList: false,
  isFetchingStylists: false,
  requestedStylists: false,
  ncob_deposit_settings: 'null',
  ncob_custom_amount: 0,
  no_show_protection: false,
  has_ncob_stripe_account: false,
  hide_client_details_for_receptionist: false,
  isPosting: false,
  has_billing: false,
  online_booking: false,
  ncob_tiny_url: '',
  fb_details: null,
  pricing_plan_id: 1,
  pricing_plan: 'Essential',
});
